import { cn } from '#/utils/cn';

export function DevSpacer({ className }: { className?: string }) {
  if (import.meta.env.DEV) {
    return (
      <div
        aria-hidden="true"
        data-dev-spacer="true"
        className={cn(
          className,
          'border-blue-20 text-slate-60 text-static-14 flex h-160 items-center justify-center border-b bg-[linear-gradient(180deg,rgba(228,234,237,0.55),rgba(244,246,248,0.9))] px-20',
        )}
      >
        Temporary dev-only spacer for sticky category navigation testing
      </div>
    );
  }

  return null;
}
